import { render, staticRenderFns } from "./RiskIcon.vue?vue&type=template&id=3500b870"
import script from "./RiskIcon.vue?vue&type=script&lang=js"
export * from "./RiskIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports